import api from '@services'

import { stripEmptyObjects } from '@utils'

const serviceBaseUrl = process.env.REACT_APP_PAYMENT_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/payment/api`

const getAllPendingRefunds = async (params) => {
  const response = await api.get(`${servicePrefix}/refunds/pending`, { params: stripEmptyObjects(params) })
  return response.data
}

const getAllRefundedList = async (params) => {
  const response = await api.get(`${servicePrefix}/refunds/refunded`, { params: stripEmptyObjects(params) })
  return response.data
}

const getRefundById = async (id) => {
  const response = await api.get(`${servicePrefix}/refunds/${id}`)
  return response.data
}

const downloadRefundLetter = async () => {
  const response = await api.get(`${servicePrefix}/refunds/pending/letter`, { responseType: 'blob' })
  return response.data
}

const exportPendingRefunds = async () => {
  const response = await api.get(`${servicePrefix}/refunds/pending/export`, { responseType: 'blob' })
  return response.data
}

const markAllPendingAsRefunded = async () => {
  const response = await api.patch(`${servicePrefix}/refunds/pending/mark-refunded`)
  return response.data
}

const createRefund = async (data) => {
  const response = await api.post(`${servicePrefix}/refunds`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

const deleteRefund = async (id) => {
  const response = await api.delete(`${servicePrefix}/refunds/${id}`)
  return response.data
}

const RefundService = {
  getAllPendingRefunds,
  getAllRefundedList,
  getRefundById,
  createRefund,
  exportPendingRefunds,
  downloadRefundLetter,
  markAllPendingAsRefunded,
  deleteRefund
}

export default RefundService
